import { Component } from '@angular/core';
import { WordpressService } from '../../../services/http/wordpress/wordpress.service';
import { WpClientCode, WpSectionCode } from '../../../services/http/wordpress/wordpress.interface';
import { ImageSectionHeadComponent } from '../../../components/image-section-head/image-section-head.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-conditions',
  standalone: true,
  imports: [CommonModule, ImageSectionHeadComponent],
  templateUrl: './conditions.component.html',
  styleUrl: './conditions.component.scss'
})
export class ConditionsComponent {
  conditionsText = '';
  title = "";
  image = "";
  description = "";

  constructor(
    private readonly wordpressService: WordpressService
  ) {
    this.wordpressService.getPost({section: WpSectionCode.useConditions, client: WpClientCode.genCat}).subscribe((response) => {
      this.conditionsText = response?.content.rendered || '';
      this.title = response?.title.rendered || '';
      this.image = response?.acf.image_url || '';
    });
  }
}
